var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCancelUpload(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M7.30469 5.75L10.0391 3.01562C10.3945 2.6875 10.3945 2.14062 10.0391 1.8125L9.4375 1.21094C9.10938 0.855469 8.5625 0.855469 8.23438 1.21094L5.5 3.94531L2.73828 1.21094C2.41016 0.855469 1.86328 0.855469 1.53516 1.21094L0.933594 1.8125C0.578125 2.14062 0.578125 2.6875 0.933594 3.01562L3.66797 5.75L0.933594 8.51172C0.578125 8.83984 0.578125 9.38672 0.933594 9.71484L1.53516 10.3164C1.86328 10.6719 2.41016 10.6719 2.73828 10.3164L5.5 7.58203L8.23438 10.3164C8.5625 10.6719 9.10938 10.6719 9.4375 10.3164L10.0391 9.71484C10.3945 9.38672 10.3945 8.83984 10.0391 8.51172L7.30469 5.75Z",
    fill: "#232323"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelUpload);
export default __webpack_public_path__ + "static/media/Cancel_upload.ab1c913d9d7585e0b250ca7c336a1acc.svg";
export { ForwardRef as ReactComponent };